import globalStyles from "../../../../assets/styles/base/globalPage.module.scss";
import { RoutedModal } from "../../../common";
import primaryComponents from "../../../primaryComponents";
import { useCategoryGroup } from "./useCategoryGroup";
import { useEffect } from "react";
import secondaryComponents from "../..";

export const CategoryGroup = ({
  rootFormDetails,
  setRootFormDetails,
  validation,
}) => {
  const { categories, isCreateCategory, setIsCreateCategory } =
    useCategoryGroup();
  const {
    control,
    formState: { errors },
    setValue,
    clearErrors,
  } = validation;

  const subCategoriesList = [
    ...new Map(
      [...(rootFormDetails?.categories || [])]
        .reverse()
        .map((categoryId) =>
          categories?.find((c) => `${c.id}` === `${categoryId}`),
        )
        .filter(Boolean)
        .flatMap((category) => category.sub_categories || [])
        .map((sub) => [sub.id, sub]),
    ).values(),
  ];

  const handleCategoryChange = (selectedCategory, key = "categories") => {
    setRootFormDetails((prev) => ({
      ...prev,
      sub_categories: [],
      [key]: selectedCategory?.map((category) => category?.value),
    }));
  };

  useEffect(() => {
    if (rootFormDetails?.categories?.length) clearErrors("categories");

    setValue("categories", rootFormDetails?.categories);
  }, [rootFormDetails?.categories]);

  return (
    <>
      <div className={`${globalStyles.cardWithBorder} light-bg mb-3`}>
        <p className="small-text-size gray--text mb-2">Category</p>

        <div
          className="d-flex flex-md-row flex-column"
          style={{ columnGap: "10px" }}
        >
          <div className="w-100">
            <primaryComponents.MultipleSelectFieldV2
              name="category"
              control={control}
              options={categories}
              label={
                <>
                  Select Category (
                  <span
                    className="purple--text cursor-pointer"
                    onClick={() => setIsCreateCategory(true)}
                  >
                    Create category
                  </span>
                  )
                </>
              }
              placeholder="Select category..."
              isRequired
              idKey="id"
              nameKey="name"
              giveControl={false}
              value={rootFormDetails?.categories
                ?.map((category_id) => {
                  const category = categories?.find(
                    (item) => `${item?.id}` === `${category_id}`,
                  );

                  if (!category) return null;

                  return {
                    label: category?.name,
                    value: category?.id,
                  };
                })
                ?.filter(Boolean)}
              errorMessage={errors?.categories}
              onChange={(values) => handleCategoryChange(values)}
            />
          </div>

          <div className="w-100">
            <primaryComponents.MultipleSelectFieldV2
              name="sub-category"
              control={control}
              options={subCategoriesList}
              label="Select Sub-category"
              placeholder="Select Sub-category"
              idKey="id"
              nameKey="name"
              giveControl={false}
              isDisabled={subCategoriesList?.length > 0 ? false : true}
              value={rootFormDetails?.sub_categories
                ?.map((category_id) => {
                  const category = subCategoriesList?.find(
                    (item) => `${item?.id}` === `${category_id}`,
                  );

                  if (!category) return null;

                  return {
                    label: category?.name,
                    value: category?.id,
                  };
                })
                ?.filter(Boolean)}
              onChange={(values) =>
                handleCategoryChange(values, "sub_categories")
              }
            />
          </div>
        </div>
      </div>

      <RoutedModal
        isActive={isCreateCategory}
        closeModal={() => setIsCreateCategory(false)}
        width={1000}
        headerTitle={"Categories"}
        headerDescription="Create and assign categories & sub-categories to your products."
      >
        <secondaryComponents.ProductCategoryForm
          setIsActive={setIsCreateCategory}
        />
      </RoutedModal>
    </>
  );
};
